import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoadingImage: false, // Loading state for the main image
  isArabicImageLoading: false, // Loading state for the Arabic image
  showPassword: false,
  seasonalThemeData: {},
  imagePreview: "",
  imageName: "",
  arabicImagePreview: "",
  arabicImageName: "",
  editSeasonalThemeData: {},
  error: "",
  statusData: {},
  isLoading: false,
  recapImagePreview: "",
  recapImageName: "",
  arabicRecapImageName: "",
  arabicRecapImagePreview: "",
  isArabicImageLoading: false,
  isLoadingArabicRecapImage: false,
};

export const getSeasonalThemeEditData = createAsyncThunk(
  "/seasonal-theme/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/seasonal-theme/edit?theme_id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const seasonalThemeSlice = createSlice({
  name: "seasonalTheme",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSeasonalThemeEditData.pending, (state, action) => {
        // state.isLoading = true;
      })
      .addCase(getSeasonalThemeEditData.fulfilled, (state, action) => {
        state.editSeasonalThemeData = action.payload?.data;
        // state.isLoading = false;
      })
      .addCase(getSeasonalThemeEditData.rejected, (state, action) => {
        // state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = seasonalThemeSlice.actions;
export default seasonalThemeSlice.reducer;
